import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { AllCustomerServiceNotesDialogComponent } from './all-customer-service-notes-dialog.component';
import { GenericListModule } from '../../generic-list';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatButtonModule, GenericListModule],
  exports: [AllCustomerServiceNotesDialogComponent],
  declarations: [AllCustomerServiceNotesDialogComponent]
})
export class AllCustomerServiceNotesDialogModule {}
